import { idApi } from '@/store/idApi'

/** Профиль из ID-сервиса (общий аккаунт студии и академии). */
export interface IdProfile {
  id: number
  email: string | null
  profileUsername: string | null
}

export interface IdError {
  data?: { code?: string; detail?: string | string[] }
}

/** Запросы те же, что в академии: аккаунт единый, ник и почта меняются везде. */
export const profileApi = idApi.injectEndpoints({
  endpoints: (build) => ({
    getIdProfile: build.query<IdProfile, void>({
      query: () => ({ url: 'users/profile/', method: 'GET' }),
    }),
    changeAvatar: build.mutation<void, { file_base64: string; is_active: boolean }>({
      query: (body) => ({ url: 'users/change-avatar/', method: 'POST', body }),
    }),
    updateProfileUsername: build.mutation<void, { id: number; profileUsername: string }>({
      query: ({ id, profileUsername }) => ({
        url: `users/${id}/`,
        method: 'PATCH',
        body: { profileUsername },
      }),
    }),
    changeEmail: build.mutation<void, { email: string }>({
      query: (body) => ({ url: 'users/change-email/', method: 'POST', body }),
    }),
    verifyEmail: build.mutation<void, { code: number }>({
      query: (body) => ({ url: 'users/verify-email/', method: 'POST', body }),
    }),
  }),
})

export const {
  useGetIdProfileQuery,
  useChangeAvatarMutation,
  useUpdateProfileUsernameMutation,
  useChangeEmailMutation,
  useVerifyEmailMutation,
} = profileApi

/** Текст ошибки ID-сервиса: известный код, потом detail, иначе запасной текст. */
export const idErrorMessage = (
  error: unknown,
  fallback: string,
  byCode: Record<string, string> = {},
): string => {
  const data = (error as IdError | undefined)?.data
  if (data?.code && byCode[data.code]) return byCode[data.code]
  const detail = Array.isArray(data?.detail) ? data?.detail[0] : data?.detail
  return typeof detail === 'string' && detail ? detail : fallback
}
